module.exports = __webpack_public_path__ + "img/20.881fa192.png";